import React from 'react'
import {
  FormField as SemanticField,
  InputProps as SemanticInputProps,
  Label
} from 'semantic-ui-react'
import { Field as FinalField } from 'react-final-form'

import { useFieldError } from '../../../hooks/useFieldError'
import { LoadingIcon } from './styles'

interface InputProps extends Omit<SemanticInputProps, 'onChange'> {
  name: string
  uppercase?: boolean
  lowercase?: boolean
  numeric?: boolean
  loading?: boolean
  autoComplete?: string
}

export const Input: React.FC<InputProps> = ({
  name,
  label,
  required,
  disabled,
  width,
  inline,
  numeric,
  lowercase,
  uppercase,
  loading,
  autoComplete,
  ...rest
}) => {
  function parseValue(value: any) {
    if (typeof value !== 'string') return value

    if (numeric) return value.replace(/[^0-9]+/g, '')
    if (lowercase) return value.toLowerCase()
    if (uppercase) return value.toUpperCase()

    return value
  }

  return (
    <FinalField
      name={name}
      required={required}
      disabled={disabled}
      parse={parseValue}
      {...rest}
    >
      {({ input, meta }) => {
        const error = useFieldError({ input, meta })

        return (
          <SemanticField
            required={required}
            disabled={disabled}
            width={width}
            inline={inline}
            error={!!error}
          >
            {label && <label htmlFor={name}>{label}</label>}

            <input
              id={name}
              type="text"
              {...input}
              {...rest}
              autoComplete={autoComplete}
            />

            {loading ? <LoadingIcon size="tiny" active inline /> : null}

            {error ? (
              <Label content={error.content} pointing={error.pointing} prompt />
            ) : null}
          </SemanticField>
        )
      }}
    </FinalField>
  )
}
